import addListeners from './add-listeners.js'
import htmlOptions from './options.html'
import htmlOptionOne from './one-option.html'
import { fillString } from '@local_modules/generic/string-template.js'
import { renderActive } from './render-active.js'
import { createElementFromHtml } from '@local_modules/generic/dom/create-elements-from-html.js'
import { renderElement } from '@local_modules/generic/dom/render-element.js'
import { fillElementHtmlId } from '../utils/fill-element-html-id.js'

const CONTAINER_ID = 'optionSelectorContent'

export default function renderOptions (selectorOptions, optionSelectorData, privateInstance) {
  // console.log('renderOptions', selectorOptions, privateInstance)
  // console.log('current value', privateInstance.api.getValue())

  if (!privateInstance.data.htmlElement) {
    createModuleElement(privateInstance)
  }
  const moduleElement = privateInstance.data.htmlElement
  renderElement(CONTAINER_ID, moduleElement)

  renderActive(optionSelectorData, privateInstance)
}

/**
 * Creates the module DOM Element, and its listeners, without inserting it in the actual DOM.
 * @param {*} privateInstance
 * @returns
 */
function createModuleElement (privateInstance) {
  const elementData = fillElementHtmlId(htmlOptions)
  privateInstance.data.htmlElementId = elementData.id
  const htmlString = elementData.html

  const moduleElement = createElementFromHtml(htmlString)

  // The sub elements:
  privateInstance.data.allowedChoices.forEach(function (oneOption) {
    // console.log('oneCurrency', oneCurrencySymbol)
    const currencyHtml = fillString(htmlOptionOne, {
      optionValue: oneOption.value,
      optionLabel: oneOption.label
    })
    moduleElement.innerHTML += currencyHtml
  })

  privateInstance.data.htmlElement = moduleElement
  addListeners(privateInstance)

  return moduleElement
}
